import request from '@/utils/request'
import {
    fileService
} from "@/api/common/file-utils";
export default {
    getList: (data) => {
        return request({
            url: 'bc/query',
            method: 'post',
            data: data
        })
    },
    getDetail: (id) => {
        return request({
            url: `bc/queryBcInfo/${id}`,
            method: 'GET',
        })
    },
    save: (data) => request({
        url: `bc/save`,
        method: 'post',
        data: data
    }),
    submit: (data) => request({
        url: `bc/submit`,
        method: 'post',
        data: data
    }),
    direct: (data) => request({
        url: `bc/direct`,
        method: 'post',
        data: data
    }),
    approval: (data) => request({
        url: `bc/complete`,
        method: 'post',
        data: data
    }),
    getCategoryLeader: (data) => request({
        url: `categoryLeader/findList`,
        method: 'post',
        data: data
    }),
    getCategoryLeaderUser: (data) => request({
        url: `categoryLeader/findUserList`,
        method: 'post',
        data: data
    }),
    queryPrimaryKey: () => {
        return request({
            url: '/bc/queryPrimaryKey',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
        })
    },
    querySsrByNo: (ssrNo, type) => {
        return request({
            url: `bc/querySsrByNo/${ssrNo}/${type}`,
            method: 'GET',
        })
    },
    recall: (ttBcId) => {
        return request({
            url: `/bc/recall/${ttBcId}`,
            method: 'get',
        })
    }
}